// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3r2gS","sendOtp":"AuthorizeToLogin_sendOtp__2bi9r"};